import { render, staticRenderFns } from "./ClientInformations.vue?vue&type=template&id=2defa087&scoped=true&"
import script from "./ClientInformations.vue?vue&type=script&lang=js&"
export * from "./ClientInformations.vue?vue&type=script&lang=js&"
import style0 from "./ClientInformations.vue?vue&type=style&index=0&id=2defa087&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defa087",
  null
  
)

export default component.exports